import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import Pool from '../UserPool';
import { Auth } from 'aws-amplify';



export const authenticate = async (Username, Password) =>
  await new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username, Pool });
    const authDetails = new AuthenticationDetails({ Username, Password });
    user.authenticateUser(authDetails, {
      onSuccess: (session) => {
        const accessToken = session.getAccessToken().getJwtToken();
        if (accessToken) {
          localStorage.setItem('token', accessToken);
          localStorage.setItem('username', Username);
        }
        user.getUserAttributes((err, attributes) => {
          if (err) {
            console.error('Error getting user attributes', err);
            reject(err);
            return;
          }
          const userAttributes = {};
          attributes.forEach((attribute) => {
            userAttributes[attribute.getName()] = attribute.getValue();
          });

          resolve({ session, userAttributes });
        });
      },
      onFailure: (err) => {
        console.error('Authentication failed', err);
        reject(err);
      },
      newPasswordRequired: (data) => {
        console.log('New password required', data);
        resolve(data);
      },
    });
  });

export const getOrgFromCognito = () => {
  const username = localStorage.getItem('username');

  if (!username) {
    return Promise.reject('No username found');
  }

  const user = new CognitoUser({
    Username: username,
    Pool
  });

  return new Promise((resolve, reject) => {
    user.getUserAttributes((err, attributes) => {
      if (err) {
        reject(err);
        return;
      }

      const org = attributes.find(attr => attr.getName() === 'custom:org')?.getValue();
      if (org) {
        resolve(org);
      } else {
        reject('No org found');
      }
    });
  });
};

export const getLoggedInUserOrg = async () => {
  try {
    const currentUser = await Auth.currentAuthenticatedUser();
    
    const userAttributes = currentUser.attributes;
    const orgAttribute = userAttributes['custom:org'];

    return orgAttribute;
  } catch (error) {
    console.error('No authenticated user found:', error);
    
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token');
      
      window.location.href = '/login';
    }
    
    return null;
  }
}

export const getLoggedInUserRole = async () => {
  try {
    const currentUser = await Auth.currentAuthenticatedUser();
    const role = currentUser.attributes?.['custom:role'];
    return role ? String(role).trim().toLowerCase() : null;
  } catch (error) {
    console.error('No authenticated user found:', error);
    return null;
  }
}

export const getLoggedInUserId = async () => {
  try {
    const currentUser = await Auth.currentAuthenticatedUser();
    
    const userAttributes = currentUser.attributes;
    const userId = userAttributes['sub'];

    return userId;
  } catch (error) {
    console.error('No authenticated user found:', error);
    
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token');
      
      window.location.href = '/login';
    }
    
    return null;
  }
}

const sessionHeaders = (session) => ({
  token: session.getAccessToken().getJwtToken(),
  "id-token": session.getIdToken().getJwtToken(),
});

export const customFetch = async (url, options = {}) => {
  try {
    const session = await Auth.currentSession();
    const headers = {
      ...options.headers,
      "Content-Type": "application/json",
      ...sessionHeaders(session),
    };

    let response = await fetch(url, { ...options, headers });

    if (response.status !== 401) {
      return response;
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: true });
      const newSession = await Auth.currentSession();
      Object.assign(headers, sessionHeaders(newSession));
    } catch (refreshError) {
      console.log("Token refresh error:", refreshError);
      handleTokenExpiration();
      throw new Error("Session expired");
    }

    response = await fetch(url, { ...options, headers });

    if (response.status === 401) {
      handleTokenExpiration();
      throw new Error("Session expired");
    }

    return response;
  } catch (error) {
    if (error.message === "Session expired") throw error;
    console.error("Request failed:", error);

    if (error.message && error.message.includes("No current user")) {
      handleTokenExpiration();
    }

    throw error;
  }
};

export const customFetchM = async (url, options = {}) => {
  try {
    const session = await Auth.currentSession();
    const headers = {
      ...options.headers,
      ...sessionHeaders(session),
    };

    let response = await fetch(url, { ...options, headers });

    if (response.status !== 401) {
      return response;
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: true });
      const newSession = await Auth.currentSession();
      Object.assign(headers, sessionHeaders(newSession));
    } catch (refreshError) {
      console.log("Token refresh error:", refreshError);
      handleTokenExpiration();
      throw new Error("Session expired");
    }

    response = await fetch(url, { ...options, headers });

    if (response.status === 401) {
      handleTokenExpiration();
      throw new Error("Session expired");
    }

    return response;
  } catch (error) {
    if (error.message === "Session expired") throw error;
    console.error("Request failed:", error);

    if (error.message && error.message.includes("No current user")) {
      handleTokenExpiration();
    }

    throw error;
  }
};

// New function to handle token expiration
export const handleTokenExpiration = () => {
  // Show notification to user
  const notification = document.createElement('div');
  notification.className = 'fixed top-4 right-4 bg-light-purple text-ktx-navy py-3 px-6 rounded-md shadow-lg z-50';
  notification.textContent = 'Your session has expired. Please log in again.';
  document.body.appendChild(notification);
  
  // Clear entire storage to be thorough
  localStorage.clear();
  
  // Wait briefly so user can see notification, then redirect
  setTimeout(() => {
    // Remove notification
    if (document.body.contains(notification)) {
      document.body.removeChild(notification);
    }
    
    // Redirect to login
    window.location.href = '/login';
  }, 2000);
};

// Check token on page load
export const checkTokenOnLoad = () => {
  try {
    // Try to get current session
    Auth.currentSession()
      .then(() => {
        // Session exists and is valid
        console.log("Valid session found");
      })
      .catch(error => {
        // No valid session
        console.log("No valid session:", error);
        
        // If there's a token in localStorage but no valid session, clear it
        if (localStorage.getItem('token')) {
          handleTokenExpiration();
        }
      });
  } catch (error) {
    console.error("Error checking session:", error);
  }
};